import { render, staticRenderFns } from "./pWareItem.vue?vue&type=template&id=67d82d9a&scoped=true&"
import script from "./pWareItem.vue?vue&type=script&lang=js&"
export * from "./pWareItem.vue?vue&type=script&lang=js&"
import style0 from "./pWareItem.vue?vue&type=style&index=0&id=67d82d9a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d82d9a",
  null
  
)

export default component.exports